angular.module('trainerWebApp.services').factory('getStartedUpload', ['$http', function ($http) {
  var swfu;
  var isUploading = false;
  var uploadToken;
  var lastConvertPercent = -1;
  var lastPercent = -1;
  var convertStatus;
  var percentTrackers = {};

  var fileDialogCompleteHandler;
  var fileDialogStartHandler;
  var uploadStartHandler;
  var uploadProgressHandler;
  var uploadSuccessHandler;
  var fileUploadErrorHandler;

  var conversionStartHandler;
  var conversionErrorHandler;
  var conversionSuccessHandler;
  var conversionProgressHandler;

  var enqueueConversionRequest;
  var currentUseSampleFileRequest;
  var currentGetConvertStatus;


  var defaultError = {
    title: "",
    message: "",
    isCanceled: false,
    isLogRequired: false,
    isShowError: true,
    isRequiredUserPermissionToUseFile: true
  };


  function initUploader(config) {
    var innerConfig = _.defaults(config, {
      fileSelectorSwfId: "fileSelectorSwf",
      button_width: 315,
      button_height: 33,
      fileDialogCompleteHandler: function (numFilesSelected, numFilesQueued) {
      },
      fileDialogStartHandler: function () {
      },
      uploadStartHandler: function () {
      },
      uploadProgressHandler: function (bytesLoaded, bytesTotal) {
      },
      uploadSuccessHandler: function (serverData) {
      },
      fileUploadErrorHandler: function (error) {
      },
      conversionStartHandler: function (data) {
      },
      conversionErrorHandler: function (error) {
      },
      conversionSuccessHandler: function (convertStatus) {
      },
      conversionProgressHandler: function (convertStatus) {
      }

    });

    fileDialogCompleteHandler = innerConfig.fileDialogCompleteHandler;
    fileDialogStartHandler = innerConfig.fileDialogStartHandler;
    fileUploadErrorHandler = innerConfig.fileUploadErrorHandler;
    uploadStartHandler = innerConfig.uploadStartHandler;
    uploadProgressHandler = innerConfig.uploadProgressHandler;
    uploadSuccessHandler = innerConfig.uploadSuccessHandler;

    conversionStartHandler = innerConfig.conversionStartHandler;
    conversionErrorHandler = innerConfig.conversionErrorHandler;
    conversionSuccessHandler = innerConfig.conversionSuccessHandler;
    conversionProgressHandler = innerConfig.conversionProgressHandler;


    swfu = new SWFUpload({
      flash_url: "scripts/vendor/swfupload.swf",
      file_size_limit: mfConfig.upload.fileSizeLimit,
      file_types: mfConfig.upload.fileTypes,
      file_types_description: mfConfig.upload.fileTypesDescription,
      file_upload_limit: 0, //User can retry upload
      file_queue_limit: 1,
      debug: false,

      // Button Settings
      button_placeholder_id: innerConfig.fileSelectorSwfId,
      button_width: innerConfig.button_width,
      button_height: innerConfig.button_height,
      button_window_mode: SWFUpload.WINDOW_MODE.TRANSPARENT,
      button_cursor: SWFUpload.CURSOR.HAND,
      button_action: SWFUpload.BUTTON_ACTION.SELECT_FILE,
      file_queue_error_handler: fileQueueError,
      file_dialog_complete_handler: fileDialogComplete,
      file_dialog_start_handler: fileDialogStart,
      upload_start_handler: function (file) {
        uploadStartHandler();
      },
      upload_progress_handler: function (file, bytesLoaded, bytesTotal) {
        uploadProgressHandler(bytesLoaded, bytesTotal);
      },
      upload_error_handler: uploadError,
      upload_success_handler: uploadSuccess,

      // SWFObject settings
      minimum_flash_version: mfConfig.MinimumFlashVersionRequired
    });
  }

  function destroy() {
    swfu.destroy();
  }

  function fileQueueError(file, errorCode, message) {
    var fileTypes = mfConfig.upload.fileTypes.replace(/\*\./g, '');
    var fileTypesArr = fileTypes.split(';');
    var fileTypesDesc = fileTypesArr.join(', ');

    switch (errorCode) {
      case SWFUpload.QUEUE_ERROR.FILE_EXCEEDS_SIZE_LIMIT:
        fileUploadErrorHandler(_.defaults({
          title: "Unsupported File Size",
          message: 'Mindflash can\'t upload this file because it exceeds the maximum file size. Files may not exceed 350 megabytes.' }, defaultError));
        break;
      case SWFUpload.QUEUE_ERROR.ZERO_BYTE_FILE:
        fileUploadErrorHandler(_.defaults({
          title: "Unsupported File Size",
          message: 'The file you are trying to upload is invalid. Please try uploading a different file.' }, defaultError));
        break;
      case SWFUpload.QUEUE_ERROR.INVALID_FILETYPE:
        fileUploadErrorHandler(_.defaults({
          title: "File Type Not Supported",
          message: 'Mindflash can\'t upload this file because it is an unsupported file type.\n\nYou can upload the following file types for your presentation: ' +  fileTypesDesc }, defaultError));
        break;
      default:
        if (file !== null) {
          fileUploadErrorHandler(_.defaults({
            title: "File Type Not Supported",
            message: 'Mindflash can\'t upload this file because it is an unsupported file type.\n\nYou can upload the following file types for your presentation: ' + fileTypesDesc }, defaultError));
          break;
        }
        fileUploadErrorHandler(_.defaults({message: message, isLogRequired: true, isShowError: false}, defaultError));
    }
  }

  function fileDialogComplete(numFilesSelected, numFilesQueued) {
    /* fileDialogComplete fires AFTER any queue error events are thrown. Starting upload only if file was queued.*/

    fileDialogCompleteHandler(numFilesSelected, numFilesQueued);

    if (numFilesQueued > 0) {
      initUploadState();
      this.startUpload();
      isUploading = true;
    }
  }

  function fileDialogStart() {
    fileDialogStartHandler();
  }

  function initUploadState() {
    percentTrackers = {};
    convertStatus = null;
    lastConvertPercent = -1;
    lastPercent = -1;
    uploadToken = guidGenerator();
    swfu.setPostParams({
      uploadToken: uploadToken,
      sessId: mfConfig.sessionId
    });

    swfu.setUploadURL('/TrainerGS/upload');

    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      };
      return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }
  }

  function uploadError(file, errorCode, message) {
    isUploading = false;

    if (errorCode == SWFUpload.UPLOAD_ERROR.FILE_CANCELLED) {
      fileUploadErrorHandler(_.defaults({message: message, isCanceled: true}, defaultError));
      return;
    }

    fileUploadErrorHandler(_.defaults({
      title: "Internet Connection Lost",
      message: "Sorry, it appears your internet connection has been lost and your file hasn\'t been uploaded. You should check your connection, refresh the page, then re-upload your file.",
      isLogRequired: true
    }, defaultError));
  }

  function uploadSuccess(file, serverData) {
    isUploading = false;
    uploadSuccessHandler(serverData);
  }

  function cancelUpload() {
    mfConfig.canceledTokens.push(uploadToken);
    if (isUploading) {
      swfu.cancelUpload();
    }

    clearInterval(conversionPollingInterval);

    if (enqueueConversionRequest) {
      enqueueConversionRequest.abort();
      enqueueConversionRequest = null;
    }

    if (currentUseSampleFileRequest) {
      currentUseSampleFileRequest.abort();
      currentUseSampleFileRequest = null;
    }

    if (currentGetConvertStatus) {
      currentGetConvertStatus.abort();
      currentGetConvertStatus = null;
    }
  }

  function getLastUploadToken() {
    return uploadToken;
  }

  function post(uri, data, cb) {
    $.ajax(uri, {
      type: 'POST',
      data: data,
      success: cb,
      dataType: "json"
    });
  }

  function enqueueConversion() {
    var params = {
      uploadToken: uploadToken,
      sessId: mfConfig.sessionId
    };
    enqueueConversionRequest = post("/TrainerGS/FinishUploadStartConversion", params,
      function (data) {
        enqueueConversionRequest = null;

        if (data.success) {
          conversionStartHandler(data);
          startConversionPolling(data.courseID);
        } else {
          conversionErrorHandler(_.defaults({ title: data.errorTitle, message: data.errorMessage, isRequiredUserPermissionToUseFile: false }, defaultError));
        }

      });
  }

  function useSampleFile(cb) {
    var params = {
      sessId: mfConfig.sessionId
    };
    currentUseSampleFileRequest = post("/TrainerGS/UseSampleCourse", params, function (data) {
      currentUseSampleFileRequest = null;
      startConversionPolling(data.courseID);
      cb(data);
    });
  }

  var convertStatus;

  function useSampleYammerFile(courseID, cb) {
    var data = {
      courseID: courseID,
      thumbnailUrl: "not specified"
    };
    setTimeout(function () {
      startConversionPolling(data.courseID);
      cb(data);
      convertStatus = { courseID: data.courseID, isComplete: true, thumbnailUrl: "not needed", percent: 100 };
    }, 500);
  }


  var conversionPollingInterval;
  var pollingCourseId;

  function startConversionPolling(courseId) {
    pollingCourseId = courseId;
    clearInterval(conversionPollingInterval);
    conversionPollingInterval = setInterval(pollStatus, 1000);
  }

  function pollStatus() {
    if (convertStatus && convertStatus.isComplete) {
      return onStatusUpdate(); //If conversion is already done and we're justing waiting on the appload, no need to keep banging on the server
    }

    if (currentGetConvertStatus) {
      return;
    }

    var params = {
      uploadToken: uploadToken,
      sessId: mfConfig.sessionId,
      courseID: pollingCourseId
    };

    currentGetConvertStatus = post("/TrainerGS/GetConvertStatus", params, function (data) {
      convertStatus = data;

      onStatusUpdate();

      currentGetConvertStatus = null;
    });

  }

  function onStatusUpdate() {
    conversionProgressHandler(convertStatus);

    if (convertStatus.isComplete && mfConfig.appLoadPercent >= 100 && convertStatus.thumbnailUrl) {
      clearInterval(conversionPollingInterval);
      conversionSuccessHandler(convertStatus);
    } else if (convertStatus.convertFailed || convertStatus.courseRemoved) {
      clearInterval(conversionPollingInterval);
      conversionErrorHandler(_.defaults({
        title: convertStatus.errorTitle,
        message: convertStatus.errorMessage,
        isRequiredUserPermissionToUseFile: convertStatus.requireUserPermissionToUseFile }, defaultError));
    }
  }


  return {
    initUploader: initUploader,
    cancelUpload: cancelUpload,
    getLastUploadToken: getLastUploadToken,
    enqueueConversion: enqueueConversion,
    useSampleFile: useSampleFile,
    startConversionPolling: startConversionPolling,
    useSampleYammerFile: useSampleYammerFile,
    destroy: destroy
  };
}]);

